export default __webpack_public_path__ + "static/media/instruction.96e664a9.pdf";